import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  // 定义状态
  state: {
    root: 0
  },
  mutations: {
    changeDataMut (state, msg) {
      state.root = msg
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js